<template>
  <div>
    <v-card v-if="template" outlined>
      <v-card-title>{{ title }}</v-card-title>

      <v-card-text>
        <v-btn-toggle v-model="previewToggle" mandatory class="mb-2">
          <v-btn value="w" icon small>
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>

          <v-btn value="r" icon small>
            <v-icon small>mdi-eye</v-icon>
          </v-btn>
        </v-btn-toggle>

        <div v-if="previewToggle === 'w'">
          <v-textarea
            v-model="form.content"
            outlined
            placeholder="Digite o template com variáveis..."
            auto-grow
          ></v-textarea>

          <div>
            <v-chip
              readonly
              @click="handleClickCopy(item.code)"
              v-for="item in template.vars"
              :key="item.code"
              small
              class="mr-2"
            >
              <v-icon small left>mdi-content-copy</v-icon>
              {{ item.name }}
            </v-chip>
          </div>
        </div>
        <div v-else>
          <v-textarea
            v-model="preview"
            :loading="loadingPreview"
            outlined
            auto-grow
            readonly
          ></v-textarea>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="!disabled" @click="handleRevert" text>
          <v-icon left>mdi-keyboard-return</v-icon>
          Reverter
        </v-btn>
        <v-btn @click="handleSubmit" color="primary" :disabled="disabled">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { show, update, preview } from "@/services/text_templates";
import ToastsMixin from "@/mixins/ToastsMixin.vue";

export default {
  mixins: [ToastsMixin],

  components: {},

  props: {
    id: String,
    title: String,
  },

  data() {
    return {
      loading: false,
      template: null,
      form: {},
      submitting: false,
      previewToggle: "w",
      preview: "",
      loadingPreview: false,
    };
  },

  methods: {
    setTemplate(template) {
      this.template = { ...template };
      this.form = { ...template };
    },

    async load() {
      this.loading = true;
      try {
        const response = await show(this.id);
        this.setTemplate(response.data);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async handleSubmit() {
      this.submitting = true;
      try {
        const response = await update(this.id, this.form);
        this.setTemplate(response.data);
        this.toast("Salvo");
      } catch (error) {
        console.error(error);
      } finally {
        this.submitting = false;
      }
    },

    async loadPreview() {
      this.preview = "";
      this.loadingPreview = true;
      try {
        const response = await preview(this.id, { content: this.form.content });
        this.preview = response.data.preview;
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingPreview = false;
      }
    },

    handleRevert() {
      this.form.content = this.template.content;
    },

    handleClickCopy(variableCode) {
      navigator.clipboard.writeText(`{{ ${variableCode} }}`);
      this.toast("Copiado");
    },
  },

  watch: {
    previewToggle(value) {
      if (value === "r") {
        this.loadPreview();
      }
    },
  },

  computed: {
    disabled() {
      return this.form.content === this.template.content;
    },
  },

  created() {
    this.load();
  },
};
</script>
